export default function HeroSection() {
  return (
    <section className="relative min-h-[600px] flex items-center justify-center overflow-hidden bg-gradient-to-br from-slate-900 via-teal-900 to-slate-900">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: 'linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)',
        backgroundSize: '50px 50px'
      }}></div>

      {/* Gradient Orbs */}
      <div className="absolute top-20 left-1/4 w-96 h-96 bg-teal-500/20 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-20 right-1/4 w-96 h-96 bg-cyan-500/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
        <div className="inline-flex items-center px-6 py-3 bg-white/10 backdrop-blur-md rounded-full mb-8 border border-white/20">
          <i className="ri-hand-coin-line text-teal-400 text-xl mr-3"></i>
          <span className="text-sm font-bold text-white">会社売却サポート</span>
        </div>

        <h1 className="text-5xl md:text-7xl font-black text-white mb-8 leading-tight">
          会社を<span className="bg-gradient-to-r from-teal-400 to-cyan-400 bg-clip-text text-transparent">売却</span>する
        </h1>

        <p className="text-xl text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed">
          売主様は手数料ゼロ。休眠会社、赤字会社、許認可ありの会社まで<br />
          小規模M&Aならなんでもご相談ください
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-16">
          <a
            href="#process"
            className="group px-10 py-5 bg-gradient-to-r from-teal-500 to-cyan-500 text-white rounded-full font-bold text-lg hover:shadow-2xl hover:shadow-teal-500/30 transition-all duration-300 flex items-center whitespace-nowrap cursor-pointer"
          >
            売却の流れを見る
            <i className="ri-arrow-down-line ml-3 group-hover:translate-y-1 transition-transform"></i>
          </a>
          <a
            href="#contact"
            className="group px-10 py-5 bg-white/10 backdrop-blur-md text-white rounded-full font-bold text-lg border-2 border-white/30 hover:bg-white hover:text-gray-900 transition-all duration-300 flex items-center whitespace-nowrap cursor-pointer"
          >
            無料相談する
            <i className="ri-arrow-right-line ml-3 group-hover:translate-x-1 transition-transform"></i>
          </a>
        </div>

        {/* Key Points */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {[
            { icon: 'ri-money-dollar-circle-line', title: '売主様手数料ゼロ', desc: '売却時の手数料は一切不要' },
            { icon: 'ri-shield-check-line', title: '安心安全な取引', desc: '契約書作成・本人確認を徹底' },
            { icon: 'ri-time-line', title: '最短3ヶ月で成約', desc: '約5割が3ヶ月以内に成約' }
          ].map((item, index) => (
            <div key={index} className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 hover:bg-white/20 transition-all duration-300">
              <div className="w-14 h-14 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className={`${item.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-lg font-black text-white mb-2">{item.title}</h3>
              <p className="text-sm text-gray-300">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
